import React from 'react';
import { DocumentArrowDownIcon } from '@heroicons/react/24/outline';

export default function UpgradeToExportButton() {
  return (
    <div className="relative group">
      {/* The disabled button */}
      <button
        disabled
        className="relative flex items-center bg-gray-800 text-gray-500 px-3 py-2 rounded-md cursor-not-allowed"
      >
        <DocumentArrowDownIcon className="h-5 w-5" />
      </button>

      {/* The tooltip that appears on hover */}
      <div 
        // 👇 The classes on this line have been changed to position the tooltip downwards
        className="absolute right-0 top-full mt-2 w-48 origin-top-right rounded-md backdrop-blur-md bg-black/90 border border-white/20 shadow-lg z-50 p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
      >
        <p className="text-sm text-white font-semibold">Export Your Chat</p>
        <p className="text-xs text-white/70 mt-1 mb-2">
          Download your conversations as PDF, TXT, or MD files.
        </p>
        <a
          href="/upgrade"
          className="block w-full text-center text-sm bg-purple-600 hover:bg-purple-700 text-white font-bold py-1.5 rounded transition pointer-events-auto"
        >
          Upgrade to Professional
        </a>
      </div>
    </div>
  );
}